import { render, staticRenderFns } from "./type4.vue?vue&type=template&id=70c2dafe&scoped=true&"
import script from "./type4.vue?vue&type=script&lang=js&"
export * from "./type4.vue?vue&type=script&lang=js&"
import style0 from "./type4.vue?vue&type=style&index=0&id=70c2dafe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2dafe",
  null
  
)

export default component.exports